import React from 'react'

const Heading = () => {
     var today = new Date(),
    todaydate=today.getDate()+ '/' + (today.getMonth()+1)+ '/'+ today.getFullYear();
    return (
        <div className='container'>
        <h1>Birthday Reminder</h1>
        <h2>Todays Date: {todaydate}</h2>
        <section >
          <div className='item' id="items">
              <span><h2>Name</h2></span>
              <span ><h2>Age</h2></span>
              <span><h2>Clear Item</h2></span>
          </div>
         
        </section>
        </div>

        
    )
}

export default Heading
